import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dpi');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dpi',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dpi/view.scss */
:host {
  display: block;
  height: 100%;
  background: #f1f5f9;
}

.report-sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  background: #0f172a;
}
.report-sidebar::-webkit-scrollbar {
  width: 0;
}

.report-content::-webkit-scrollbar {
  width: 6px;
}
.report-content::-webkit-scrollbar-track {
  background: transparent;
}
.report-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.report-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.nav-item {
  transition: all 0.15s ease;
  border-left: 2px solid transparent;
  color: #94a3b8;
}
.nav-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #e2e8f0;
}
.nav-item.active {
  background: rgba(59, 130, 246, 0.1);
  border-left-color: #3b82f6;
  color: #60a5fa;
  font-weight: 600;
}

.section-card {
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.kpi-card {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  transition: background 0.15s ease;
}
.kpi-card:hover {
  background: rgba(255, 255, 255, 0.12);
}

.hero-gradient {
  background: linear-gradient(160deg, #0f172a 0%, #1e293b 40%, #1e3a5f 100%);
}

.grade-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  font-weight: 800;
  font-size: 14px;
  border-width: 1px;
}

.data-table th {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  padding: 10px 16px;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}
.data-table td {
  font-size: 13px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
}
.data-table tr:last-child td {
  border-bottom: none;
}
.data-table .row-recommended {
  background: #eff6ff;
}
.data-table .row-benchmark {
  background: #f8fafc;
}

.bar-bg {
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.5s ease;
}

.bar-bg-lg {
  height: 10px;
  background: #e2e8f0;
  border-radius: 5px;
  overflow: hidden;
}

.bar-fill-lg {
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s ease;
}

.tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.tag-recommended {
  background: #dbeafe;
  color: #1e40af;
}

.tag-benchmark {
  background: #e2e8f0;
  color: #475569;
}

.formula-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-family: "SF Mono", "JetBrains Mono", "Fira Code", monospace;
  font-size: 13px;
  color: #334155;
}

.metric-card {
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.footer-brand {
  background: #0f172a;
  color: #64748b;
}

.heatmap-cell {
  width: 56px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: white;
}

.callout {
  border-radius: 6px;
  border-left: 3px solid;
}

.callout-info {
  background: #f0f9ff;
  border-left-color: #3b82f6;
}

.callout-warn {
  background: #f8fafc;
  border-left-color: #94a3b8;
}

.rec-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: box-shadow 0.15s ease;
}
.rec-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}
.rec-card.rec-primary {
  border-color: #3b82f6;
  border-width: 2px;
  background: #f0f9ff;
}
.rec-card.rec-secondary {
  background: #f8fafc;
}
.rec-card.rec-baseline {
  background: #fafafa;
}

.summary-bar {
  background: #1e293b;
  border-radius: 8px;
}

.scenario-tab {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.scenario-tab:hover {
  background: #f8fafc;
  color: #334155;
  border-color: #cbd5e1;
}
.scenario-tab.active {
  background: #1e40af;
  color: white;
  border-color: #1e40af;
  font-weight: 600;
}`],
})
export class PageDpiComponent implements OnInit {

    public activeSection: string = 'overview';

    public sections: any[] = [
        { id: 'overview', label: '개요', icon: 'fa-solid fa-house' },
        { id: 'methodology', label: '비교 방법론', icon: 'fa-solid fa-flask' },
        { id: 'results', label: '종합 비교표', icon: 'fa-solid fa-table' },
        { id: 'weight', label: '가중치 시나리오', icon: 'fa-solid fa-sliders' },
        { id: 'analysis', label: 'DPI별 분석', icon: 'fa-solid fa-chart-bar' },
        { id: 'files', label: '파일별 관찰', icon: 'fa-solid fa-file-lines' },
        { id: 'cost', label: '비용 관점', icon: 'fa-solid fa-coins' },
        { id: 'recommendation', label: '최종 권고', icon: 'fa-solid fa-check-circle' },
    ];

    public dpiData: any[] = [
        { dpi: 150, totalSec: 1200.202, avgSec: 240.040, quality: 90.16, cost: 42.02, efficiency: 2.1457, p95: 68, p99: 15 },
        { dpi: 200, totalSec: 1136.555, avgSec: 227.311, quality: 91.95, cost: 41.87, efficiency: 2.1961, p95: 71, p99: 16 },
        { dpi: 300, totalSec: 1242.023, avgSec: 248.405, quality: 92.49, cost: 50.90, efficiency: 1.8172, p95: 79, p99: 23 },
        { dpi: 400, totalSec: 1296.064, avgSec: 259.213, quality: 91.34, cost: 60.45, efficiency: 1.5109, p95: 72, p99: 23 },
        { dpi: 500, totalSec: 1587.705, avgSec: 317.541, quality: 93.14, cost: 80.06, efficiency: 1.1634, p95: 76, p99: 21 },
        { dpi: 600, totalSec: 1822.185, avgSec: 364.437, quality: 100.00, cost: 100.00, efficiency: 1.0000, p95: 100, p99: 100 },
    ];

    // 가중치 시나리오별 결과
    public weightScenarios: any[] = [
        {
            name: '기본 (50:50)', qWeight: 50, cWeight: 50,
            desc: '품질과 비용을 동등하게 반영',
            topPick: 200,
            ranking: [200, 150, 300, 400, 500, 600],
            scores: [
                { dpi: 150, score: 74.07 },
                { dpi: 200, score: 75.04 },
                { dpi: 300, score: 70.80 },
                { dpi: 400, score: 65.44 },
                { dpi: 500, score: 56.54 },
                { dpi: 600, score: 50.00 },
            ]
        },
        {
            name: '품질 중심 (70:30)', qWeight: 70, cWeight: 30,
            desc: '품질에 더 비중을 두되 비용도 고려',
            topPick: 200,
            ranking: [200, 150, 300, 400, 500, 600],
            scores: [
                { dpi: 150, score: 80.51 },
                { dpi: 200, score: 81.80 },
                { dpi: 300, score: 79.47 },
                { dpi: 400, score: 75.80 },
                { dpi: 500, score: 71.18 },
                { dpi: 600, score: 70.00 },
            ]
        },
        {
            name: '품질 우선 (80:20)', qWeight: 80, cWeight: 20,
            desc: '품질을 크게 우선, 비용은 참고 수준',
            topPick: 200,
            ranking: [200, 300, 150, 400, 600, 500],
            scores: [
                { dpi: 150, score: 83.72 },
                { dpi: 200, score: 85.18 },
                { dpi: 300, score: 83.81 },
                { dpi: 400, score: 80.98 },
                { dpi: 500, score: 78.50 },
                { dpi: 600, score: 80.00 },
            ]
        },
        {
            name: '품질 극대 (90:10)', qWeight: 90, cWeight: 10,
            desc: '비용은 거의 무시, 품질 극대화',
            topPick: 600,
            ranking: [600, 200, 300, 150, 400, 500],
            scores: [
                { dpi: 150, score: 86.94 },
                { dpi: 200, score: 88.57 },
                { dpi: 300, score: 88.15 },
                { dpi: 400, score: 86.16 },
                { dpi: 500, score: 85.82 },
                { dpi: 600, score: 90.00 },
            ]
        },
        {
            name: '품질 전용 (100:0)', qWeight: 100, cWeight: 0,
            desc: '비용 완전 무시, 오직 품질만',
            topPick: 600,
            ranking: [600, 500, 300, 200, 400, 150],
            scores: [
                { dpi: 150, score: 90.16 },
                { dpi: 200, score: 91.95 },
                { dpi: 300, score: 92.49 },
                { dpi: 400, score: 91.34 },
                { dpi: 500, score: 93.14 },
                { dpi: 600, score: 100.00 },
            ]
        },
    ];

    public activeScenario: number = 0;

    public perFileData: any[] = [
        {
            name: '견비통 임상진료지침', short: '견비통',
            scores: [
                { dpi: 150, composite: 0.9387 },
                { dpi: 200, composite: 0.9374 },
                { dpi: 300, composite: 0.9801 },
                { dpi: 400, composite: 0.9375 },
                { dpi: 500, composite: 0.9334 },
                { dpi: 600, composite: 1.0000 },
            ]
        },
        {
            name: '상한론정해-3', short: '상한론',
            scores: [
                { dpi: 150, composite: 0.8926 },
                { dpi: 200, composite: 0.9280 },
                { dpi: 300, composite: 0.9353 },
                { dpi: 400, composite: 0.9358 },
                { dpi: 500, composite: 0.9332 },
                { dpi: 600, composite: 1.0000 },
            ]
        },
        {
            name: '폐계내과학', short: '폐계내과',
            scores: [
                { dpi: 150, composite: 0.9454 },
                { dpi: 200, composite: 0.9516 },
                { dpi: 300, composite: 0.9688 },
                { dpi: 400, composite: 0.9635 },
                { dpi: 500, composite: 0.9691 },
                { dpi: 600, composite: 1.0000 },
            ]
        },
        {
            name: '대전대 학술논문', short: '대전대',
            scores: [
                { dpi: 150, composite: 0.8162 },
                { dpi: 200, composite: 0.8526 },
                { dpi: 300, composite: 0.7961 },
                { dpi: 400, composite: 0.7947 },
                { dpi: 500, composite: 0.8735 },
                { dpi: 600, composite: 1.0000 },
            ]
        },
        {
            name: '한방병리 초록', short: '한방병리',
            scores: [
                { dpi: 150, composite: 0.9152 },
                { dpi: 200, composite: 0.9278 },
                { dpi: 300, composite: 0.9441 },
                { dpi: 400, composite: 0.9355 },
                { dpi: 500, composite: 0.9476 },
                { dpi: 600, composite: 1.0000 },
            ]
        },
    ];

    public dpiAnalysis: any[] = [
        {
            dpi: 150, grade: 'C+', gradeColor: 'text-slate-500 bg-slate-50 border-slate-200',
            summary: '빠르고 저렴하지만, 기준 운영값으로 쓰기엔 200DPI보다 이점이 크지 않다.',
            pros: ['600DPI 대비 비용 프록시가 매우 낮다'],
            cons: ['품질 손실이 상대적으로 크고, 페이지별 흔들림이 있다'],
        },
        {
            dpi: 200, grade: 'A', gradeColor: 'text-blue-700 bg-blue-50 border-blue-200',
            summary: '품질 87% 이하 가중치에서 항상 1위. 실서비스 기본값으로 최적.',
            pros: ['전체 처리 시간이 가장 짧다', '품질지수 91.95%로 150DPI보다 개선', '품질 가중치 87%까지 1위 유지'],
            cons: [],
        },
        {
            dpi: 300, grade: 'B+', gradeColor: 'text-blue-600 bg-sky-50 border-sky-200',
            summary: '비기준선 DPI 중 페이지 일치도가 가장 안정적이다.',
            pros: ['0.95 이상 페이지가 79/100으로 가장 많다', '품질 민감 문서에 적합'],
            cons: ['200DPI 대비 시간·비용 증가'],
        },
        {
            dpi: 400, grade: 'B-', gradeColor: 'text-slate-500 bg-slate-50 border-slate-200',
            summary: '300DPI 대비 우위가 명확하지 않다.',
            pros: ['일부 파일에서 유사도 유지'],
            cons: ['평균 품질이 300DPI보다 오히려 낮다'],
        },
        {
            dpi: 500, grade: 'B', gradeColor: 'text-indigo-600 bg-indigo-50 border-indigo-200',
            summary: '품질 100% 기준에서 2위지만, 비용 조금만 반영하면 순위 하락.',
            pros: ['600DPI에 가장 가까운 평균 품질 (93.14%)'],
            cons: ['시간과 비용 프록시가 대폭 증가', '비용 10%만 반영해도 5위로 하락'],
        },
        {
            dpi: 600, grade: 'S', gradeColor: 'text-slate-700 bg-slate-100 border-slate-300',
            summary: '품질 88% 이상 가중치에서 1위. 벤치마크 기준으로 적합.',
            pros: ['기준선 — 가장 높은 화질 가정에 부합', '품질 가중치 88% 이상에서 1위'],
            cons: ['시간이 가장 오래 걸리고 비용 프록시 최고'],
        },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async scrollTo(sectionId: string) {
        this.activeSection = sectionId;
        const el = document.getElementById('section-' + sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        await this.service.render();
    }

    public async selectScenario(idx: number) {
        this.activeScenario = idx;
        await this.service.render();
    }

    public getScenarioScore(dpi: number): number {
        const sc = this.weightScenarios[this.activeScenario];
        const entry = sc.scores.find((s: any) => s.dpi === dpi);
        return entry ? entry.score : 0;
    }

    public getScenarioRank(dpi: number): number {
        const sc = this.weightScenarios[this.activeScenario];
        return sc.ranking.indexOf(dpi) + 1;
    }

    public isScenarioTop(dpi: number): boolean {
        return this.weightScenarios[this.activeScenario].topPick === dpi;
    }

    public getScenarioBarColor(dpi: number): string {
        if (this.isScenarioTop(dpi)) return 'bg-blue-600';
        if (this.getScenarioRank(dpi) <= 2) return 'bg-blue-400';
        return 'bg-slate-300';
    }

    public getQualityColor(quality: number): string {
        if (quality >= 100) return 'bg-slate-700';
        if (quality >= 93) return 'bg-blue-700';
        if (quality >= 91) return 'bg-blue-500';
        if (quality >= 90) return 'bg-blue-400';
        return 'bg-slate-400';
    }

    public getEfficiencyColor(eff: number): string {
        if (eff >= 2.0) return 'text-blue-700';
        if (eff >= 1.5) return 'text-blue-500';
        if (eff >= 1.1) return 'text-slate-600';
        return 'text-slate-400';
    }

    public getCompositeColor(val: number): string {
        if (val >= 1.0) return 'bg-slate-700';
        if (val >= 0.95) return 'bg-blue-700';
        if (val >= 0.92) return 'bg-blue-500';
        if (val >= 0.88) return 'bg-blue-400';
        return 'bg-slate-400';
    }

    public getRowClass(dpi: number): string {
        if (dpi === 200) return 'row-recommended';
        if (dpi === 600) return 'row-benchmark';
        return '';
    }

    public isRecommended(dpi: number): boolean {
        return dpi === 200;
    }

    public isBenchmark(dpi: number): boolean {
        return dpi === 600;
    }
}

export default PageDpiComponent;